import { useEffect } from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { FaQuoteLeft } from 'react-icons/fa'

const testimonials = [
  {
    id: 1,
    name: 'Jesse Hinaman',
    role: ' Equip Scale Strategies LLC',
    feedback:
      'Absolutely fantastic experience! The professionalism and quality of work exceeded my expectations.',
    image: '/images/jesse.jpg',
  },
  {
    id: 2,
    name: 'Brain Harbour ',
    role: 'Real Deal Home Solutions',
    feedback:
      'A truly skilled developer! The attention to detail and problem-solving skills are outstanding.',
    image: '/images/Brain.png',
  },
  {
    id: 3,
    name: 'Jake Cross',
    role: ' Cycl Sales',
    feedback:
      'Great work! The UI/UX was smooth, responsive, and exactly what we envisioned.',
    image: '/images/Jake Cross.jpeg',
  },
]

export default function Testimonials() {
  useEffect(() => {
    AOS.init({ duration: 1000 })
  }, [])

  return (
    <section id="testimonials" className=" px-6 sm:px-12 lg:px-20">
      <h2 className="text-lg leading-7">Client Reviews</h2>
      <p className="mt-2 text-4xl font-bold tracking-tight sm:text-6xl">
        Testimonials
      </p>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
        {testimonials.map((testimonial) => (
          <div
            key={testimonial.id}
            className="group relative bg-base-200 ring-2 ring-base-300 rounded-2xl shadow-lg p-6 transition-transform transform hover:scale-105"
            data-aos="fade-up"
          >
            <FaQuoteLeft className="text-4xl text-gray-400 dark:text-gray-600" />
            <p className="mt-4 text-lg text-base-content">
              {testimonial.feedback}
            </p>
            <div className="mt-6 flex items-center space-x-4">
              <img
                src={testimonial.image}
                alt={testimonial.name}
                className="w-12 h-12 rounded-full border-2 border-gray-300"
              />
              <div>
                <h3 className="text-xl font-bold text-base-content">
                  {testimonial.name}
                </h3>
                <p className="text-sm text-gray-400">{testimonial.role}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
